import { render, staticRenderFns } from "./injured-info.vue?vue&type=template&id=3f508dc4&"
import script from "./injured-info.vue?vue&type=script&lang=js&"
export * from "./injured-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports